import styled, { css, createGlobalStyle } from "styled-components";
export const GlobalNotificationStyle = createGlobalStyle(["body[data-page='order']{[class*='LayoutStyled__Container']{max-width:1224px;padding-left:0;padding-right:0;}.notification{margin-bottom:1.5rem;margin-bottom:1.25rem;}}"]);
const NotificationsStyled = styled.div.attrs(() => ({
  className: "notification"
})).withConfig({
  displayName: "NotificationsStyled",
  componentId: "sc-vc4f5m-0"
})(["", ""], ({
  theme,
  type
}) => {
  const {
    colors,
    media
  } = theme;
  return css(["align-items:center;background:", ";border-radius:3px;color:", ";display:flex;font-size:16px;padding:20px 24px;position:relative;margin-bottom:40px;white-space:pre-wrap;", "{margin-bottom:48px;}a{text-decoration:underline;}.tooltip .tooltip-button svg{height:auto;margin-right:0;}.notification{&__message{line-height:1.4;", "{flex-direction:column;}}&__status-icon{fill:currentColor;flex:0 0 24px;margin-right:24px;svg{height:24px;width:24px;}}&__button{cursor:pointer;margin-left:24px;flex:0 0 16px;}}"], colors.notification[type || "info"], theme.colors.black, media.tablet.up, media.tablet.down);
});
export default NotificationsStyled;